import styled from "styled-components";

export const Wrapper = styled.div`
  .contact-info-wrapper {
    .left,
    .right {
      flex: 0 0 40%;
      min-height: 1px;
    }
  }
 
`;
export const FilterWrapper = styled.div` 
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  .transactionfilter {

    .filterinputbox{
        flex: auto !important;
        width: 15%;
        max-width: 250px;
      }
   }
   .gap10 {
  
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
    &>div{
      min-width: 200px;
    max-width: 250px;
    flex: 1 1 200px;
    }
}
.agentlist
{
  position: absolute;
  left: 69%;
  width: 300px;
  z-index: 99999;
  border: 1px solid;
  background: #fff;
  max-height: 285px;
  overflow: hidden;
  overflow-y: scroll;
  top: 293px;
  ul li {
    padding: 10px;
  }
}
`;
